export default "__VITE_ASSET__DNzhbti4__"